import { Customer } from "frontend-lib/DomainTypes/Customer";
import { atom } from "jotai";

type OptInVisibleWithCustomerType = {
    visible: boolean;
    customer?: Customer;
};

export const optInVisibleWithCustomerAtom = atom<OptInVisibleWithCustomerType>({ visible: false });
